import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import Report from '../../../../common/types/api/report'

import publishReport from '../../../../api/publishReport'
import getReport from '../../../../api/getReport'
import { sleep } from '../../../../api/helper'
import i18n from 'live/services/i18n'

import { PublishButton, Bar, Back, ArrowBack, BackSection, SectionModifiers } from './styles'
import { 
    filterAllowedReportLink, 
    REPORT_PREVIEW_LINK 
} from '../../reportLinks'

export default function BarPostReport({ report }: { report: Report }): JSX.Element {
    const [state, setState] = useState<{
        hasNewChanges?: boolean
        published?: boolean
        loading?: boolean
    }>({
        hasNewChanges: false,
        published: !report?.isDraft
    })

    useEffect(() => {
        if (report?.isDraft) {
            setState({ ...state, hasNewChanges: true, published: false })
        }

        // eslint-disable-next-line
    }, [report])

    const history = useHistory()
    const showPublishButton = filterAllowedReportLink()
        .filter(({ link }) => link !== REPORT_PREVIEW_LINK)
        .length > 0

    return (
        <Bar>
            <BackSection>
                <Link
                    component={ArrowBack}
                    to={{
                        pathname: '/'
                    }}
                ></Link>
                <Back>Back to Reports</Back>
            </BackSection>
            {(() => {
                const uid = report?.uid

                if (!uid && uid !== 'new') return null

                return (
                    <SectionModifiers>
                        {showPublishButton ? (
                            <PublishButton
                                published={!report.isDraft || state.published}
                                disabled={!report.isDraft || state.published}
                                onClick={async () => {
                                    setState({ ...state, loading: true })
                                    publishReport(report.uid)
                                    sleep(1000).then(async () => {
                                        const checkPublish = await getReport(report.uid)
                                        if (!checkPublish.isDraft) {
                                            report.isDraft = false // just to update the full bar state
                                            setState({ ...state, loading: false })
                                        } else {
                                            report.isDraft = true // just to update the full bar state
                                            sleep(1000).then(() => setState({ ...state, loading: false }))
                                        }
                                    })
                                }}
                            >
                                <i
                                    className={
                                        state.loading
                                            ? 'fas fa-spinner fa-pulse'
                                            : state.published || !report?.isDraft
                                            ? 'far fa-check-circle'
                                            : 'far fa-share-square'
                                    }
                                />
                                {state.loading
                                    ? i18n('Publishing...')
                                    : state.published || !report.isDraft
                                    ? i18n('Published')
                                    : i18n('Publish Report')}
                            </PublishButton>
                        ) : (
                            <div />
                        )}
                    </SectionModifiers>
                )
            })()}
        </Bar>
    )
}
